// src/hooks/usePointerEvents.js
import { useEffect } from "react";

// Utility function to determine if an element or its ancestors are interactive
function isClickInsideInteractiveElement(element) {
  const interactiveTags = ["BUTTON", "A", "INPUT", "SELECT", "TEXTAREA"];
  let currentElement = element;

  while (currentElement && currentElement !== document.body) {
    if (interactiveTags.includes(currentElement.tagName)) {
      return true;
    }

    // Check for specific class indicating interactivity
    if (currentElement.classList.contains("interactive-element")) {
      return true;
    }

    currentElement = currentElement.parentElement;
  }

  return false;
}

export const usePointerEvents = ({
  pointerLocation,
  clickedItem,
  cardRefs,
  setSelectedCard,
}) => {
  useEffect(() => {
    const handlePointerUp = (e) => {
      // If the click came from an interactive element, ignore it.
      if (isClickInsideInteractiveElement(e.target)) {
        return;
      }

      // Calculate the movement distance.
      const { x, y } = pointerLocation.current;
      const distanceMoved = Math.sqrt(
        Math.pow(e.clientX - x, 2) + Math.pow(e.clientY - y, 2)
      );

      // If the pointer hasn't moved much and there's a clicked item...
      if (distanceMoved < 10 && clickedItem.current) {
        const itemId = clickedItem.current.id;
        const cardRef = cardRefs.current[itemId];

        // If a valid action function exists on the card, execute it.
        if (
          cardRef &&
          cardRef.current &&
          typeof cardRef.current.action === "function"
        ) {
          cardRef.current.action(setSelectedCard);
        } else {
          console.warn("No action function found for item", itemId);
        }
      }

      // Reset the clicked item reference.
      clickedItem.current = null;
    };

    window.addEventListener("pointerup", handlePointerUp);
    window.addEventListener("touchend", handlePointerUp); // 👈 NEW
    return () => {
      window.removeEventListener("pointerup", handlePointerUp);
      window.removeEventListener("touchend", handlePointerUp); // 👈 NEW
    };
  }, [pointerLocation, clickedItem, cardRefs, setSelectedCard]);
};
